"use strict";

define('components/agreement',['components/form', 'components/ajax'], function(form, ajax) {
    var agreementComponent = {
        init: function() {
            agreementComponent.initSelectAllHandler();
            agreementComponent.initViewAllHandler();
            agreementComponent.initSignatureBlock();
            agreementComponent.initSubmitHandler();
        },

        initSelectAllHandler: function() {
            // One-way select-all for investment entities
            $('.select-all-entities').click(function() {
                $(".electronic-delivery-prefs tr:not(.hidden) input:radio[value='electronic']").prop('checked', true);
                // Turn on the signature block
                $('#signature-block').removeClass('hidden');
                $('#settings-block').addClass('hidden');
                $('#submit-button').text('Record signature')
                                   .removeClass('disabled');
            });
        },

        initViewAllHandler: function() {
            // One-way view-all for investment entities that already have a preference
            $('.view-all-entities').click(function() {
                $("table.table tr.hidden").removeClass('hidden');
            });
        },

        initSignatureBlock: function() {
            // Show the 'accept signature' block only if there is at least one entity with pref 'electronic'
            $(".electronic-delivery-prefs input:radio").change(function() {
                var electronicPrefCount = $(".electronic-delivery-prefs tr:not(.hidden) input:radio[value='electronic']:checked").length;
                // Relable the submit button as appropriate and enable it on any change
                if (electronicPrefCount > 0) {
                    // Turn on the signature block
                    $('#signature-block').removeClass('hidden');
                    $('#settings-block').addClass('hidden');
                    $('#submit-button').text('Record signature');
                } else {
                    // Turn off the signature block
                    $('#signature-block').addClass('hidden');
                    $('#settings-block').removeClass('hidden');
                    $('#submit-button').text('Save preference');
                }

                var prefCount = $(".electronic-delivery-prefs tr:not(.hidden) input:radio:checked").length;
                if (prefCount == $(".electronic-delivery-prefs tr:not(.hidden)").length) {
                    $('#submit-button').removeClass('disabled');
                }
            });
        },

        initSubmitHandler: function() {
            // Submit button handler.  Include only prefs from visible entities
            $('#submit-button').click(function(e) {
                var edcForm = $('#edc-form');
                var formData = new FormData();
                var button = $(e.target);
    
                // Start with the __start__ of the sequence
                formData.append('__start__',  'prefs:sequence');
    
                var visibleRowInputs = $('.electronic-delivery-prefs tr:not(.hidden) input');
                for (var i=0; i < visibleRowInputs.length; i++) {
                    if (visibleRowInputs[i].type == 'radio') {
                        if (visibleRowInputs[i].checked) {
                            formData.append(visibleRowInputs[i].name, visibleRowInputs[i].value);
                        }
                    } else {
                        formData.append(visibleRowInputs[i].name, visibleRowInputs[i].value);
                    }
                }
    
                // Append with the __end__ of the sequence
                formData.append('__end__',  'prefs:sequence');
    
                // Append the checkbox and full_name from the signature block
                if ($('#accept_consent').prop('checked')) {
                    formData.append('accept_consent', $('#accept_consent').val());
                }
                formData.append('full_name', $('#full_name').val());

                button.addClass('disabled').prop('disabled', true);
                ajax(edcForm.attr('action'), {
                    formData: formData,
                    onFailure: function(result) {
                        button.removeClass('disabled').prop('disabled', false);
                    },
                    onError: function(result) {
                        button.removeClass('disabled').prop('disabled', false);
                    },
                    onSuccess: function(result){
                        button.removeClass('disabled').prop('disabled', false);
                    }
                });
            });
        },
    };
    return agreementComponent;
});

